import { RemoteGetAllCitiesForSelectOptions } from 'data/usecases/locations';
import { GetAllCitiesForSelectOptionsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllCitiesForSelectOptions =
  (): GetAllCitiesForSelectOptionsUseCaseInterface =>
    new RemoteGetAllCitiesForSelectOptions(
      makeApiUrlCities(),
      makeAxiosHttpClient(),
    );
